import { render, staticRenderFns } from "./weights-panel.vue?vue&type=template&id=19af6072&scoped=true&"
import script from "./weights-panel.vue?vue&type=script&lang=ts&"
export * from "./weights-panel.vue?vue&type=script&lang=ts&"
import style0 from "./weights-panel.vue?vue&type=style&index=0&id=19af6072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19af6072",
  null
  
)

export default component.exports